import React, {useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import {TextBreak} from "../../../Components";


const TextSec = ({item}) =>{
    const history = useHistory()
    return(
        <div className="page" >
            <div className="storeDetail-container">


                {/*About*/}
                <div className="storeDetail-about">
                    <div className="storeDetail-about-titre">
                        <span>{item.items[0]?item.items[0].title:""}</span>
                    </div>

                    <div className="storeDetail-about-body">
                        {/*<span>{event && event.body}</span>*/}
                        {item.items[0] && item.items[0].text?<TextBreak text={item.items[0].text}/>:null}
                    </div>
                </div>


            </div>
        </div>
    )
}

export {TextSec}
